import { DepositType } from '@wix/ambassador-wix-quotes-web/types';
import * as React from 'react';
import { translate } from 'react-i18next';
import { SubtotalsListItem } from '../SubtotalsListItem';
export var Deposit = translate()(function (_a) {
    var depositAmount = _a.depositAmount, hasDeposit = _a.hasDeposit, depositRate = _a.depositRate, depositType = _a.depositType, moneyFormatter = _a.moneyFormatter, fraction = _a.fraction, t = _a.t;
    return hasDeposit ? (React.createElement(SubtotalsListItem, { dataHook: "deposit", label: depositType === DepositType.PERCENTAGE
            ? "".concat(t('quote.form.deposit'), " (").concat(Number((depositRate * 100).toFixed(fraction)), "%)")
            : "".concat(t('quote.form.deposit')), value: moneyFormatter(depositAmount) })) : null;
});
//# sourceMappingURL=Deposit.js.map